export default "__VITE_ASSET__BQrwpoLp__"